import React, { useCallback } from 'react';
import { Redirect, useLocalSearchParams, useRouter } from 'expo-router';

import { useIsFocused } from '@garnish/core';

import { useCart } from '../../hooks';
import { DeliveryCustomization } from './components';

// ────────────────────────────────────────────────────────────────────────────────

export const CustomizationDeliveryEditScreen = () => {
  const isScreenFocused = useIsFocused();
  const router = useRouter();
  const routeParams = useLocalSearchParams<CustomizationDeliveryEditScreenRouteParams>();

  const { cart } = useCart();

  const { addressId, productSlug, lineItemId } = routeParams;

  const lineItems = cart?.lineItems;
  const isLineItemInCart = lineItems?.some(({ id }) => id === lineItemId);

  // ─────────────────────────────────────────────────────────────────

  const navigateToBag = useCallback(() => {
    try {
      router.dismissTo('/bag');
    } catch {
      // expo-router throws if called before Root Layout mounts
    }
  }, [router]);

  // ─────────────────────────────────────────────────────────────────

  // Redirect to the related delivery menu screen if the line item isn't in the cart or has been removed
  if (isScreenFocused && !isLineItemInCart) {
    return <Redirect href={{ pathname: '/delivery/[addressId]/menu', params: { addressId } }} />;
  }

  // ─────────────────────────────────────────────────────────────────

  return (
    <DeliveryCustomization
      addressId={addressId}
      productSlug={productSlug}
      lineItemId={lineItemId}
      isEditProductMode={true}
      onEditLineItemInCart={navigateToBag}
      onRemoveLineItemFromCart={navigateToBag}
    />
  );
};

// ─── Types ───────────────────────────────────────────────────────────────────

type CustomizationDeliveryEditScreenRouteParams = {
  addressId: string;
  productSlug: string;
  lineItemId: string;
};
